var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    !_vm.initialized
      ? _c("div", [_c("span", [_vm._v("Loading...")])])
      : _c("div", [
          _vm.description
            ? _c("div", { staticClass: "alert alert-info" }, [
                _vm._v(_vm._s(_vm.description))
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("table", { staticClass: "table table-striped table-bordered" }, [
            _c("thead", [
              _c(
                "tr",
                [
                  _c("th", [_vm._v("Door/Model")]),
                  _vm._v(" "),
                  _vm._l(_vm.rows, function(row) {
                    return _c("th", { staticClass: "text-center" }, [
                      _vm._v(_vm._s(row.name))
                    ])
                  })
                ],
                2
              )
            ]),
            _vm._v(" "),
            _c(
              "tbody",
              _vm._l(_vm.cols, function(col) {
                return _c(
                  "tr",
                  [
                    _c("td", [_c("strong", [_vm._v(_vm._s(col.name))])]),
                    _vm._v(" "),
                    _vm._l(_vm.rows, function(row) {
                      return _c("td", [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.matrix[row.id + "-" + col.id].value,
                              expression: "matrix[row.id + '-' + col.id].value"
                            }
                          ],
                          key: row.id + "_" + col.id + "-" + _vm.timestamp,
                          staticClass: "form-control text-center",
                          attrs: { type: "number" },
                          domProps: {
                            value: _vm.matrix[row.id + "-" + col.id].value
                          },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.matrix[row.id + "-" + col.id],
                                "value",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ])
                    })
                  ],
                  2
                )
              }),
              0
            )
          ]),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-rounded btn-icon btn-sm btn-primary mt-3",
              attrs: { type: "button" },
              on: { click: _vm.submitMatrix }
            },
            [
              _c("i", { staticClass: "material-icons" }, [_vm._v("save")]),
              _vm._v("Save\n        ")
            ]
          )
        ])
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3c7fe0c7", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c7fe0c7","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./seventytwo/72cms-ui/src/components/helpers/MatrixInputComponent.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-3c7fe0c7","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./seventytwo/72cms-ui/src/components/helpers/MatrixInputComponent.vue
// module chunks = 0